define('AwaLabs.Moment', [
    'Moment',
    'Moment.TZ'
], function AwaLabsMoment(
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {}
    };
});
